import axiosClient from "../../../../../system/helpers/axiosConfig";
export const getManageableListItem = (id) => {
  return axiosClient.get(`api/admin/manageable-list/${id}`).then((r) => r.data);
};
